<template>
  <div>
    <div
      class="goodsManageSet"
      :class="{ fixedStyle: isShowStyle }"
      :style="{ top: scrollTop + 'px' }"
    >
      <div class="banner">
        <img src="../../../assets/images/banner1.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <div class="breadcrumb_icon">
          <i class="iconfont icon-shangpinsku"></i>
        </div>
        <div class="breadcrumb_item">SKU管理</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">商品管理</div>
      </div>

      <div class="main_content">
        <div class="tit">多币种价格设置</div>
        <div class="primary-button account_btn" @click="handleAccount">
          自动汇率核算
        </div>
        <div class="block">
          <div class="block_item">
            <h1>越南盾零售底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.yue_price_base"
                placeholder="越南盾零售底价"
                @focus="inputFocus"
                @blur="inputBlur"
              ></van-field>
            </div>
          </div>
          <div class="block_item">
            <h1>越南盾团批底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.yue_tuan_base"
                placeholder="越南盾团批底价"
                @focus="inputFocus"
                @blur="inputBlur"
              ></van-field>
            </div>
          </div>
          <div class="block_item">
            <h1>越南盾零售价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.yue_price"
                placeholder="越南盾零售价"
                @focus="inputFocus"
                @blur="inputBlur"
              ></van-field>
            </div>
          </div>
          <div class="block_item">
            <h1>越南盾团批价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.yue_tuan"
                placeholder="越南盾团批价"
                @focus="inputFocus"
                @blur="inputBlur"
              ></van-field>
            </div>
          </div>
        </div>

        <div class="block">
          <div class="block_item">
            <h1>泰铢零售底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.tai_price_base"
                placeholder="铢零售底价"
              ></van-field>
            </div>
          </div>
          <div class="block_item">
            <h1>泰铢团批底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.tai_tuan_base"
                placeholder="泰铢团批底价"
              ></van-field>
            </div>
          </div>
          <div class="block_item">
            <h1>泰铢零售价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.tai_price"
                placeholder="泰铢零售价"
              ></van-field>
            </div>
          </div>
          <div class="block_item">
            <h1>泰铢团批价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.tai_tuan"
                placeholder="泰铢团批价"
              ></van-field>
            </div>
          </div>
        </div>

        <div class="block">
          <div class="block_item">
            <h1>卢布零售底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.lu_price_base"
                placeholder="卢布零售底价"
              ></van-field>
            </div>
          </div>
          <div class="block_item">
            <h1>卢布团批底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.lu_tuan_base"
                placeholder="卢布团批底价"
              ></van-field>
            </div>
          </div>
          <div class="block_item">
            <h1>卢布零售价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.lu_price"
                placeholder="卢布零售价"
              ></van-field>
            </div>
          </div>
          <div class="block_item">
            <h1>卢布团批价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.lu_tuan"
                placeholder="卢布团批价"
              ></van-field>
            </div>
          </div>
        </div>

        <div class="block">
          <div class="block_item">
            <h1>加拿大元零售底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.jia_price_base"
                placeholder="加拿大元零售底价"
              ></van-field>
            </div>
          </div>
          <div class="block_item">
            <h1>加拿大元团批底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.jia_tuan_base"
                placeholder="加拿大元团批底价"
              ></van-field>
            </div>
          </div>
          <div class="block_item">
            <h1>加拿大元零售价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.jia_price"
                placeholder="加拿大元零售价"
              ></van-field>
            </div>
          </div>
          <div class="block_item">
            <h1>加拿大元团批价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.jia_tuan"
                placeholder="加拿大元团批价"
              ></van-field>
            </div>
          </div>
        </div>
      </div>

      <div class="primary-button" @click="query">保存确认</div>

      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div>
    </div>
  </div>
</template>

<script>
import { encryptstringview } from "../../../api/api";
import { mapState } from "vuex";
import {
  accountShopMultiPrice,
  getShopMultiPrice,
  addShopMultiPrice,
  editShopMultiPrice,
} from "../../../api/shop";
export default {
  name: "cMultiPrice",
  data() {
    return {
      isShowStyle: false,
      scrollTop: 0,
      formData: {
        cmid: "",
        yue_price_base: "",
        yue_tuan_base: "",
        yue_price: "",
        yue_tuan: "",
        tai_price_base: "",
        tai_tuan_base: "",
        tai_price: "",
        tai_tuan: "",
        lu_price_base: "",
        lu_tuan_base: "",
        lu_price: "",
        lu_tuan: "",
        jia_price_base: "",
        jia_tuan_base: "",
        jia_price: "",
        jia_tuan: "",
      },
      multiPriceDetail: "",
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.cmid = id;
        this.getShopMultiPrice();
      } else {
        this.$router.back();
      }
    },

    getShopMultiPrice() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getShopMultiPrice({ cmid: this.formData.cmid }).then((res) => {
        this.multiPriceDetail = res;
        if (res.id) {
          this.formData.yue_price_base = res.yue_price_base;
          this.formData.yue_tuan_base = res.yue_tuan_base;
          this.formData.yue_price = res.yue_price;
          this.formData.yue_tuan = res.yue_tuan;
          this.formData.tai_price_base = res.tai_price_base;
          this.formData.tai_tuan_base = res.tai_tuan_base;
          this.formData.tai_price = res.tai_price;
          this.formData.tai_tuan = res.tai_tuan;
          this.formData.lu_price_base = res.lu_price_base;
          this.formData.lu_tuan_base = res.lu_tuan_base;
          this.formData.lu_price = res.lu_price;
          this.formData.lu_tuan = res.lu_tuan;
          this.formData.jia_price_base = res.jia_price_base;
          this.formData.jia_tuan_base = res.jia_tuan_base;
          this.formData.jia_price = res.jia_price;
          this.formData.jia_tuan = res.jia_tuan;
        }

        Toast.clear();
      });
    },
    // 多币种自动核算
    handleAccount() {
      accountShopMultiPrice({ cmid: this.formData.cmid }).then((res) => {
        this.formData.yue_price_base = res.yue_price_base;
        this.formData.yue_tuan_base = res.yue_tuan_base;
        this.formData.yue_price = res.yue_price;
        this.formData.yue_tuan = res.yue_tuan;
        this.formData.tai_price_base = res.tai_price_base;
        this.formData.tai_tuan_base = res.tai_tuan_base;
        this.formData.tai_price = res.tai_price;
        this.formData.tai_tuan = res.tai_tuan;
        this.formData.lu_price_base = res.lu_price_base;
        this.formData.lu_tuan_base = res.lu_tuan_base;
        this.formData.lu_price = res.lu_price;
        this.formData.lu_tuan = res.lu_tuan;
        this.formData.jia_price_base = res.jia_price_base;
        this.formData.jia_tuan_base = res.jia_tuan_base;
        this.formData.jia_price = res.jia_price;
        this.formData.jia_tuan = res.jia_tuan;
      });
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },

    handleReturn() {
      history.back();
    },

    query() {
      let { formData, multiPriceDetail } = this;
      if (formData.yue_price_base == "") {
        this.$toast("请输入越南盾零售底价");
        return;
      }
      if (formData.yue_tuan_base == "") {
        this.$toast("请输入越南盾团批底价");
        return;
      }
      if (formData.yue_price == "") {
        this.$toast("请输入越南盾零售价");
        return;
      }
      if (formData.yue_tuan == "") {
        this.$toast("请输入越南盾团批价");
        return;
      }
      if (formData.tai_price_base == "") {
        this.$toast("请输入铢零售底价");
        return;
      }
      if (formData.tai_tuan_base == "") {
        this.$toast("请输入泰铢团批底价");
        return;
      }
      if (formData.tai_price == "") {
        this.$toast("请输入泰铢零售价");
        return;
      }
      if (formData.tai_tuan == "") {
        this.$toast("请输入泰铢团批价");
        return;
      }
      if (formData.lu_price_base == "") {
        this.$toast("请输入卢布零售底价");
        return;
      }
      if (formData.lu_tuan_base == "") {
        this.$toast("请输入卢布团批底价");
        return;
      }
      if (formData.yue_price_base == "") {
        this.$toast("请输入");
        return;
      }
      if (formData.lu_price == "") {
        this.$toast("请输入卢布零售价");
        return;
      }
      if (formData.lu_tuan == "") {
        this.$toast("请输入卢布团批价");
        return;
      }
      if (formData.jia_price_base == "") {
        this.$toast("请输入加拿大元零售底价");
        return;
      }
      if (formData.jia_tuan_base == "") {
        this.$toast("请输入加拿大元团批底价");
        return;
      }
      if (formData.jia_price == "") {
        this.$toast("请输入加拿大元零售价");
        return;
      }
      if (formData.jia_tuan == "") {
        this.$toast("请输入加拿大元团批价");
        return;
      }
      let params = formData;
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      if (multiPriceDetail.id) {
        editShopMultiPrice(params).then((res) => {
          let data = res;
          if (data.result) {
            setTimeout(() => {
              Toast.clear();
              this.$toast.success(data.message);
            }, 500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addShopMultiPrice(params).then((res) => {
          let data = res;
          if (data.result) {
            setTimeout(() => {
              Toast.clear();
              this.$toast.success(data.message);
            }, 500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      .input_box {
        margin-bottom: 30px;
      }
      .limit_content {
        white-space: nowrap;
        .van_input {
          border: 1px solid #adadadc2;
          margin-left: 30px;
          border-radius: 45px;
          padding: 6px 10px;
        }
      }
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
    }
  }
  .account_btn {
    margin-bottom: 40px;
  }
}
</style>